import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { EngineHealth, EngineMetrics, QueueStats } from '@/lib/types'

const HEALTH_REFETCH_MS = 10_000
const METRICS_REFETCH_MS = 15_000

export function useEngineHealth() {
  return useQuery<EngineHealth>({
    queryKey: ['engine', 'health'],
    queryFn: () => apiClient.get<EngineHealth>(endpoints.engine.health),
    refetchInterval: HEALTH_REFETCH_MS,
  })
}

export function useQueueStats() {
  return useQuery<QueueStats>({
    queryKey: ['engine', 'queueStats'],
    queryFn: () => apiClient.get<QueueStats>(endpoints.engine.queueStats),
    refetchInterval: HEALTH_REFETCH_MS,
  })
}

export function useEngineMetrics() {
  return useQuery<EngineMetrics>({
    queryKey: ['engine', 'metrics'],
    queryFn: () => apiClient.get<EngineMetrics>(endpoints.engine.metrics),
    refetchInterval: METRICS_REFETCH_MS,
  })
}

export function useFlushQueue() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => apiClient.post<void>(endpoints.engine.queueFlush),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['engine', 'queueStats'] })
      void queryClient.invalidateQueries({ queryKey: ['engine', 'health'] })
    },
  })
}
